import dayjs from 'dayjs';

import { DateTime } from '@packages/components/date-time/date-time';
import { NotificationStatusChip } from '@packages/fenrir/components';
import { Stack } from '@packages/fenrir/components/stack';

type Props = { dateTime: Date | string; daysThreshold?: number };

export const DateTimeWithNewBadge = ({
  dateTime,
  daysThreshold = 7,
}: Props) => {
  const firstDetected = dayjs(dateTime);
  const now = dayjs();
  return firstDetected.isAfter(now.subtract(daysThreshold, 'd')) ? (
    <Stack direction="row" alignItems="center" gap={1}>
      <DateTime value={dateTime} />
      <NotificationStatusChip status="new" />
    </Stack>
  ) : (
    <DateTime value={dateTime} />
  );
};
